var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderAscBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.381 39.4908L73.3321 45.9149L73.3909 6.94945C73.396 3.62313 75.8284 1.01326 78.9191 1.01793C82.0099 1.0226 84.4344 3.63981 84.4293 6.96613L84.3705 45.9316L90.3409 39.5255C92.5522 37.1529 95.9741 37.1581 98.1782 39.5374C100.382 41.9167 100.377 45.5994 98.1654 47.972L82.6867 64.4614C81.5811 65.6477 80.1452 66.2395 78.8206 66.2375C77.496 66.2355 75.9515 65.6392 74.9598 64.4497L59.6414 47.9138C57.4371 45.6533 57.4429 41.8518 59.6541 39.4792C61.7548 37.2252 65.2873 37.1117 67.381 39.4908Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5784 83.6078L7.53637 83.5186C3.32981 83.5122 0.0198409 86.6956 0.0137097 90.7536C0.00757862 94.8116 3.30791 98.005 7.51447 98.0113L66.5565 98.1006C70.7631 98.1069 74.073 94.9235 74.0792 90.8655C74.0853 86.8075 70.785 83.6141 66.5784 83.6078Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5898 66.1268L51.7666 66.1936C55.9883 66.2 59.3101 63.0164 59.3162 58.9583C59.3224 54.9002 56.0102 51.7067 51.7885 51.7003L7.6117 51.6336C3.39003 51.6272 0.0681806 54.8107 0.0620493 58.8688C0.0559179 62.9269 3.36813 66.1204 7.5898 66.1268Z",
    fill: "#113251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6564 32.795L36.9812 32.8393C41.2136 32.8457 44.5439 29.6622 44.5501 25.6041C44.5562 21.546 41.2355 18.3525 37.0031 18.3461L7.67829 18.3018C3.44585 18.2954 0.115544 21.4789 0.109413 25.537C0.103281 29.5951 3.42395 32.7886 7.6564 32.795Z",
    fill: "#113251"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderAscBlue);
export default __webpack_public_path__ + "static/media/icon-order-asc-blue.bff3c41fd8cfae76d02d9a2fb8ca7ae3.svg";
export { ForwardRef as ReactComponent };